import { motion } from "framer-motion";
import { CONFIG } from "../../lib/config";

const marqueeText = "ÉCLIPSE — LA FIN D'ÉTÉ — AKTRA — NE RATE PAS LE MOMENT —";

export default function FinalCTA() {
  return (
    <section id="billets" data-testid="final-cta-section" className="border-t border-white/10 bg-[#09090b]">
      {/* Editorial marquee */}
      <div className="overflow-hidden border-b border-white/10 py-6 lg:py-8">
        <div className="marquee-track">
          {[0, 1].map((k) => (
            <span
              key={k}
              className="font-display text-6xl uppercase tracking-tight text-white lg:text-8xl"
            >
              {Array.from({ length: 4 }).map((_, i) => (
                <span key={i} className="mx-6">
                  {marqueeText.split("—").map((chunk, j) =>
                    j % 2 === 1 ? (
                      <span key={j} className="text-[#FF0000]">
                        {" "}—{chunk}
                      </span>
                    ) : (
                      <span key={j}>{chunk}</span>
                    )
                  )}
                </span>
              ))}
            </span>
          ))}
        </div>
      </div>

      {/* Ticket block */}
      <div className="mx-auto max-w-[1600px] px-5 py-24 lg:px-10 lg:py-40">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="flex flex-col items-center text-center"
        >
          <p className="mb-6 font-mono-x text-xs uppercase tracking-[0.3em] text-[#FF0000]">
            [ Dernière chance ]
          </p>
          <h2 className="font-display text-6xl uppercase leading-[0.85] tracking-tight text-white sm:text-7xl lg:text-9xl">
            Prends ton<br />
            <span className="text-[#FF0000]">billet</span>
          </h2>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-zinc-400 lg:text-lg">
            Une seule nuit. Un premier set qui n’existera qu’une fois. Les places partent vite —
            n’attends pas de le regretter.
          </p>

          <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row">
            <a
              href="#weez-embed"
              data-testid="final-buy-ticket"
              className="glow-red group flex items-center gap-3 bg-[#FF0000] px-12 py-5 font-mono-x text-base font-semibold uppercase tracking-[0.15em] text-white hover:bg-[#ff2424]"
            >
              Acheter mon billet
              <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
            </a>
            <a
              href="#lemfi"
              data-testid="final-lemfi"
              className="font-mono-x text-xs uppercase tracking-[0.2em] text-zinc-300 link-underline"
            >
              ou débloque -30% avec LemFi
            </a>
          </div>

          <p className="mt-8 font-mono-x text-[11px] uppercase tracking-[0.25em] text-zinc-600">
            {CONFIG.location} — {CONFIG.tagline}
          </p>
        </motion.div>

        {/* Weezevent embedded ticket widget */}
        <motion.div
          id="weez-embed"
          data-testid="weez-embed"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="mx-auto mt-16 w-full max-w-4xl"
        >
          <div className="mb-4 flex items-center justify-between">
            <span className="font-mono-x text-[10px] uppercase tracking-[0.3em] text-zinc-500">
              Billetterie officielle
            </span>
            <a
              href={CONFIG.weezeventDirectUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="weez-open-tab"
              className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-zinc-400 link-underline"
            >
              Ouvrir dans un nouvel onglet ↗
            </a>
          </div>
          <div className="overflow-hidden border border-white/10 bg-white">
            <iframe
              src={CONFIG.weezeventEmbedUrl}
              title="Billetterie Weezevent — Éclipse"
              className="h-[720px] w-full"
              loading="lazy"
              allow="payment *"
            />
          </div>
          <p className="mt-3 text-center font-mono-x text-[10px] uppercase tracking-[0.25em] text-zinc-600">
            Paiement sécurisé — Weezevent
          </p>
        </motion.div>
      </div>
    </section>
  );
}
